export default __webpack_public_path__ + "static/media/Automated Ride-Sharing case study.a3186079.pdf";